<div class="card">
    <div class="card-body">
        <h6 class="ml-1 pb-1">{{ 'customerdeallist.title' | trans }}</h6>
        <a style="position: absolute; right:10px; top:10px;" data-toggle="modal" data-target="#modaldealcreate" class="cursor-default" 
        matTooltip="{{ 'customerdeallist.createdealtip' | trans }}" matTooltipPosition="above">
            <span class="material-icons bg-lightgrey p-1 f-20 rounded-circle text-secondary">
              add
              </span>
          </a>
        <div class="row">
            <div class="col-4 col-md-3">
                <p class="mb-0 f-13 text-muted pl-1">{{ 'customerdeallist.name' | trans }}</p>
            </div>
            <div class="col-2 d-none d-sm-block">
                <p class="mb-0 f-13 text-muted pl-1">{{ 'customerdeallist.owner' | trans }}</p>
            </div>
            <div class="col-4 col-md-3 d-none d-sm-block">
                <p class="mb-0 f-13 text-muted pl-1">{{ 'customerdeallist.closingdate' | trans }}</p>
            </div>
            <div class="col-3 col-md-2 d-none d-sm-block">
                <p class="mb-0 f-13 text-muted pl-1">{{ 'customerdeallist.status' | trans }}</p>
            </div>
            <div class="col-2 d-none d-sm-block">
                <p class="mb-0 f-13 text-muted pl-1">{{ 'customerdeallist.projects' | trans }}</p>
            </div>
            <div class="col-2">
          </div>

        </div>
        <div *ngFor="let deal of dealList" class="row hoverrow pt-1" (click)="openDeal(deal)">
           
            <div class="col-4 col-md-3">
                <a class="cursor-pointer" data-toggle="modal" data-target="#dealmodal"><p class="mb-0 f-13 pl-1 hover-group lh-40 align-middle cursor-pointer">{{ deal.dealname }}</p></a>
            </div>
            <div class="col-2 d-none d-sm-block">
                <a class="cursor-pointer" data-toggle="modal" data-target="#dealmodal"><p class="mb-0 f-13 pl-1 hover-group lh-40 align-middle cursor-pointer">{{ deal.dealowner }}</p></a>
            </div>
            <div class="col-4 col-md-3 d-none d-sm-block">
                <a class="cursor-pointer" data-toggle="modal" data-target="#dealmodal"><p class="mb-0 f-13 pl-1 hover-group lh-40 align-middle cursor-pointer">{{ deal.dealdate | date: 'dd-MM-yyyy' }}</p></a>
            </div>
            <div *ngIf="dealtoggler!=deal.dealId" class="col-3 col-md-2 d-none d-sm-block">
                <a class="cursor-pointer" data-toggle="modal" data-target="#dealmodal"><p class="mb-0 f-13 pl-1 hover-group lh-40 align-middle cursor-pointer">{{ deal.dealstatus }}</p></a>
            </div>
            <div *ngIf="dealtoggler!=deal.dealId" class="col-1 d-none d-sm-block">
                <a class="cursor-pointer" data-toggle="modal" data-target="#dealmodal"><p class="mb-0 f-13 pl-1 hover-group lh-40 align-middle cursor-pointer">{{ deal.projectCount }}</p></a>
            </div>
            <div class="col-1">
              <ng-container *ngIf="dealtoggler!=deal.dealId">
                <button (click)="toggleactions(deal)" style="position: absolute; top:0px; right:-17px;" class="border-0 bg-transparent mr-3" type="button">
                  <span  class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
                    more_horiz
                  </span>
              </button>
              </ng-container>
              <ng-container *ngIf="dealtoggler==deal.dealId">
                <button (click)="toggleactions(deal)" style="position: absolute; top:0px; right:-17px;" class="border-0 bg-transparent mr-3" type="button">
                  <span  class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
                    navigate_next                 
                  </span>
              </button>
              </ng-container>
            </div>
            <div *ngIf="dealtoggler==deal.dealId" class="col- pl-2">
              <app-projectwizard (projecttoadd)="addDealProject($event)" [customerId]="deal.customerId" [dealId]="deal.dealId"></app-projectwizard>
            </div>
            <div *ngIf="dealtoggler==deal.dealId" class="col-">
              <button class="border-0 bg-transparent" type="button"  
              data-toggle="modal" data-target="#modaldealcreate" 
              matTooltip="{{ 'customerdeallist.editdealtip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                <span  class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle w-35 h-35">
                    create
                </span>
            </button>
            </div>
            <div *ngIf="dealtoggler==deal.dealId" class="col-">
            <button class="border-0 bg-transparent" type="button"  
            data-toggle="modal" data-target="#dealdeleteconfirm" 
            matTooltip="{{ 'customerdeallist.deletedealtip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
              <span  class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle w-35 h-35">
                  delete
              </span>
          </button>
            </div>
      
        
        
    </div>
</div>
  <!-- Modal deal create -->
  <div class="modal fade" id="modaldealcreate" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'customerdeallist.dealcreation' | trans }}</h5>
          <button #closedealmodal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <form>
        <div class="modal-body">
            
                <div class="form-group">
                <label class="font-weight-light f-13 mb-0" for="taskstartdate">{{ 'customerdeallist.dealname' | trans }}</label>
                  <input type="text" class="form-control" id="dealnameinput" placeholder="{{ 'customerdeallist.dealnameplace' | trans }}" name="dealname" [(ngModel)]="modalDeal.dealname">
                </div>
                <div class="form-group">
                    <label class="font-weight-light f-13 mb-0" for="bv">{{ 'customerdeallist.owner' | trans }}</label>
                    <input type="text" class="form-control" id="dealownerinput" placeholder="{{ 'customerdeallist.ownerplace' | trans }}" name="dealowner" [(ngModel)]="modalDeal.dealowner">
               
                </div>
                <div class="form-group">
                    <label class="font-weight-light f-13 mb-0" for="dealdetailsinput">{{ 'customerdeallist.details' | trans }}</label>
                    <textarea class="form-control" style="height:100px;" id="dealdetailsinput" placeholder="{{ 'customerdeallist.detailsplace' | trans }}" name="dealdetail" [(ngModel)]="modalDeal.dealdetail"></textarea>
                </div>
                  <div class="form-group">
                    <label class="font-weight-light f-13 mb-0" for="dealdate">{{ 'customerdeallist.dealdate' | trans }}</label>
                    <input required  type="date" class="form-control stageinput" id="dealdate" name="dealdate" [(ngModel)]="modalDeal.dealdate">
                </div>
                <div class="form-group">
                    <label class="font-weight-light f-13 mb-0" for="dealcrmId">{{ 'customerdeallist.dealcrmid' | trans }}</label>
                    <input required  type="text" class="form-control stageinput" id="dealcrmId" name="dealcrmId" [(ngModel)]="modalDeal.dealcrmId">
                </div>
                <div class="form-group">
                    <label class="font-weight-light f-13 mb-0" for="dealstatus">{{ 'customerdeallist.status' | trans }}</label>
                    <select class="form-control" name="dealstatus" [(ngModel)]="modalDeal.dealstatus">
                        <option selected>{{ 'customerdeallist.choosedealstatus' | trans }}</option>
                        <option value="new">{{ 'customerdeallist.new' | trans }}</option>
                        <option value="handled">{{ 'customerdeallist.handled' | trans }}</option>
                        <option value="done">{{ 'customerdeallist.done' | trans }}</option>
                      </select>
                </div>
                
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'customerdeallist.cancel' | trans }}</p></button>
          <button *ngIf="!modalDeal.dealId" type="button" class="btn-save" (click)="addDeal()"><p class="btn-save-text">{{ 'customerdeallist.createdeal' | trans }}</p></button>
          <button *ngIf="modalDeal.dealId" type="button" class="btn-save" (click)="updateDeal()"><p class="btn-save-text">{{ 'customerdeallist.updatedeal' | trans }}</p></button>
        </div>
    </form>
      </div>
    </div>
  </div>

  <!-- Deal Modal -->
  <div class="modal fade" id="dealmodal" tabindex="-1" role="dialog" >
    <app-customerdeal [modalDeal]="modalDeal"></app-customerdeal>
  </div>
   <!-- Modal Delete deal CONFIRM -->
   <div id="dealdeleteconfirm" class="modal fade" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'customerdeallist.confirmdealdeletion' | trans }}</h5>
          <button #deletemodalclose type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p class="font-weight-light text-center">{{ 'customerdeallist.confirmdealdeletionmsg' | trans }}</p>
            <p class="mt-2 text-center text-muted">{{ modalDeal.dealname }}</p>
        </div>
        <div class="modal-footer">
            <div class="col">
                <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'customerdeallist.cancel' | trans }}</p></button>
            </div>
            <div class="col">
                <button (click)="deleteDeal()" type="button" class="btn-save"><p class="btn-save-text">{{ 'customerdeallist.deletedeal' | trans }}</p></button>
            </div>
        </div>
      </div>
    </div>
  </div>